import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { imageBasePath } from 'constants';
import styles from './SkillPaths.module.scss';
import { CustomButton } from 'shared_ui_components';
import SkillPathDetailModalBody from './SkillPathDetailModalBody';
import { useGetSkillPathDetailAdmin } from 'features/training/Training.queries';
const SkillPathDetailModal = ({
  skillPath = {},
  openDetailSkillPath = false,
  closeModal = () => {},
}) => {
  const { data: skillPathDetail = {}, isLoading: isLoadingSkillPathDetail } =
    useGetSkillPathDetailAdmin({
      enabled: skillPath?.uuid ? true : false && openDetailSkillPath,
      uuid: skillPath?.uuid,
    });

  const onClose = () => {
    closeModal();
  };

  return (
    <>
      <Dialog
        open={openDetailSkillPath}
        onClose={onClose}
        scroll={'paper'}
        aria-labelledby="add-video-title"
        aria-describedby="add-video-description"
        className={`dialog addVideoDialog ${styles.dialog}`}
      >
        <DialogTitle>
          <div className={styles.dialogTitle}>{skillPath?.title}</div>
          <div className={styles.dialogSubTitle}>
            Detailed information about individual sales rep within the skill path an each skill set.
          </div>
          <img
            src={imageBasePath + 'close_gray.svg'}
            alt="close icon"
            className="modalCloseIcon"
            onClick={onClose}
          />
        </DialogTitle>
        <DialogContent>
          <SkillPathDetailModalBody skillPath={skillPath} skillPathDetail={skillPathDetail} />
        </DialogContent>
        <DialogActions>
          <CustomButton onClick={onClose} className="tertiaryBtn">
            Close
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SkillPathDetailModal;
